import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../../../services';
import { AuthStore } from '../../../state/auth/auth.store';
import { SettingsStore } from '../../../state/settings/settings.store';
import { MatToolbar } from '@angular/material/toolbar';
import { RouterLink } from '@angular/router';
import { CountryLanguageSwitcherComponent } from '../country-language-switcher/country-language-switcher.component';
import { GlobalHeaderModule } from '@vi/global-header';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedUiModule } from '@nx-customer-apps/shared/ui';

@Component({
    selector: 'vp-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    imports: [MatToolbar, RouterLink, CountryLanguageSwitcherComponent, GlobalHeaderModule, AsyncPipe, TranslatePipe, SharedUiModule]
})
export class ToolbarComponent {
    public settingsStore = inject(SettingsStore);
    public authStore = inject(AuthStore);
    public environmentService = inject(EnvironmentService);

    @Input() isAuthenticated: Observable<boolean>;
    @Output() logoutClick = new EventEmitter();

    public logout(): void {
        this.logoutClick.emit();
    }
}
